module.exports = "/img/banner.df57c50a.png";